export const rewardDescriptionMap = new Map(
  Object.entries({
    Bonus: 'Bonus',
    Cash: 'Cash',
    FreeSpins: 'Free Spins',
    Coins: 'Betty Coins',
    InstantWheel: 'Wheel Spins',
  })
)